/* ============================================================================
   BYRNA — global.js
   Interacciones globales: menú off-canvas (mobile) y carruseles.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- Links externos (fuera de la tienda) → pestaña nueva ---------- */
  (function () {
    var host = window.location.hostname;
    document.querySelectorAll('a[href]').forEach(function (a) {
      try {
        var u = new URL(a.getAttribute('href'), window.location.href);
        if (u.hostname && u.hostname !== host && (u.protocol === 'http:' || u.protocol === 'https:')) {
          a.target = '_blank';
          a.rel = (a.rel ? a.rel + ' ' : '') + 'noopener';
        }
      } catch (e) {}
    });
  })();

  /* ---------- Hero slider ---------- */
  document.querySelectorAll('[data-hero-slider]').forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-hero-slide]');
    if (slides.length < 2) return;
    var dots = hero.querySelectorAll('[data-hero-dot]');
    var idx = 0, timer = null;
    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
    }
    function start() {
      if (hero.dataset.autoplay === 'true') {
        var speed = parseInt(hero.dataset.speed, 10) || 6000;
        timer = setInterval(function () { go(idx + 1); }, speed);
      }
    }
    function reset() { if (timer) { clearInterval(timer); start(); } }
    var nb = hero.querySelector('[data-hero-next]'); if (nb) nb.addEventListener('click', function () { go(idx + 1); reset(); });
    var pb = hero.querySelector('[data-hero-prev]'); if (pb) pb.addEventListener('click', function () { go(idx - 1); reset(); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); reset(); }); });
    start();
  });

  /* ---------- Menú off-canvas ---------- */
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  var backdrop = document.querySelector('[data-nav-backdrop]');

  function closeNav() {
    if (!nav) return;
    nav.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  function openNav() {
    nav.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.contains('is-open') ? closeNav() : openNav();
    });
  }
  if (backdrop) backdrop.addEventListener('click', closeNav);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });

  /* ---------- Flechas de carrusel (data-rail) ---------- */
  document.querySelectorAll('[data-rail]').forEach(function (rail) {
    var track = rail.querySelector('.h-scroll');
    if (!track) return;
    rail.querySelectorAll('[data-rail-prev],[data-rail-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.hasAttribute('data-rail-next') ? 1 : -1;
        track.scrollBy({ left: dir * (track.clientWidth * 0.8), behavior: 'smooth' });
      });
    });
  });

  /* ---------- Colección: toggle de filtros ---------- */
  var fToggle = document.querySelector('[data-filters-toggle]');
  var layout = document.querySelector('[data-collection-layout]');
  var fPanel = document.querySelector('[data-filters]');
  var fLabel = document.querySelector('[data-filters-label]');
  if (fToggle && layout) {
    fToggle.addEventListener('click', function () {
      var isMobile = window.matchMedia('(max-width: 990px)').matches;
      if (isMobile) {
        var open = fPanel.classList.toggle('is-open');
        document.body.style.overflow = open ? 'hidden' : '';
      } else {
        var hidden = layout.classList.toggle('filters-hidden');
        if (fLabel) fLabel.textContent = hidden ? 'Mostrar filtros' : 'Ocultar filtros';
        fToggle.setAttribute('aria-expanded', String(!hidden));
      }
    });
  }

  /* ---------- Colección: auto-submit de filtros y orden ---------- */
  var filtersForm = document.querySelector('[data-filters-form]');
  function submitFilters() { if (filtersForm && filtersForm.requestSubmit) filtersForm.requestSubmit(); else if (filtersForm) filtersForm.submit(); }
  document.querySelectorAll('[data-filters-form] [data-auto-submit]').forEach(function (el) {
    var evt = el.type === 'number' ? 'change' : 'change';
    el.addEventListener(evt, submitFilters);
  });
  var sortForm = document.querySelector('[data-sort-form]');
  var sortSel = sortForm && sortForm.querySelector('[data-auto-submit]');
  if (sortSel) sortSel.addEventListener('change', function () { sortForm.submit(); });

  /* ---------- PDP: galería ---------- */
  (function () {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var idx = 0;
    function show(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.style.display = n === idx ? '' : 'none'; });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === idx); });
    }
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
  })();

  /* ---------- PDP: cantidad ---------- */
  (function () {
    var input = document.querySelector('[data-qty-input]');
    if (!input) return;
    var minus = document.querySelector('[data-qty-minus]');
    var plus = document.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
  })();

  /* ---------- PDP: cambio de variante ---------- */
  (function () {
    var form = document.getElementById('product-form');
    var dataEl = document.querySelector('[data-variant-json]');
    if (!form || !dataEl) return;
    var variants = JSON.parse(dataEl.textContent || '[]');
    var idField = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var priceEl = document.querySelector('.product-info__price');
    function selectedOptions() {
      return Array.prototype.map.call(form.querySelectorAll('[data-variant-option]:checked'), function (i) { return i.value; });
    }
    function update() {
      var opts = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) return;
      idField.value = match.id;
      if (addBtn) {
        addBtn.disabled = !match.available;
        var label = addBtn.querySelector('span');
        if (label) label.textContent = match.available ? 'Agregar al Carrito' : 'Agotado';
      }
    }
    form.querySelectorAll('[data-variant-option]').forEach(function (r) { r.addEventListener('change', update); });
  })();

  /* ---------- Carrito: actualizar / quitar (AJAX Cart API) ---------- */
  (function () {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;
    function changeLine(key, qty) {
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () { window.location.reload(); });
    }
    page.addEventListener('click', function (e) {
      var item = e.target.closest('[data-cart-item]');
      if (!item) return;
      var key = item.dataset.key;
      var input = item.querySelector('[data-cart-qty]');
      if (e.target.closest('[data-cart-plus]')) changeLine(key, (parseInt(input.value, 10) || 0) + 1);
      else if (e.target.closest('[data-cart-minus]')) changeLine(key, Math.max(0, (parseInt(input.value, 10) || 0) - 1));
      else if (e.target.closest('[data-cart-remove]')) changeLine(key, 0);
    });
    page.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () { changeLine(input.dataset.key, Math.max(0, parseInt(input.value, 10) || 0)); });
    });
  })();

  /* ====================================================================
     DRAWERS: carrito (sidebar) + buscador (panel)
     ==================================================================== */
  function openDrawer(el) { if (!el) return; el.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer(el) { if (!el) return; el.classList.remove('is-open'); document.body.style.overflow = ''; }
  function closeAllDrawers() { document.querySelectorAll('.drawer.is-open').forEach(closeDrawer); }

  // Cerrar: overlay, botón cerrar, Escape
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) { closeAllDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllDrawers(); });

  // ---------- Carrito ----------
  var cartDrawer = function () { return document.getElementById('CartDrawer'); };

  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      });
  }

  function replaceCartDrawer(html) {
    var wrap = document.getElementById('shopify-section-cart-drawer');
    if (wrap) { wrap.innerHTML = html; }
  }

  function cartChange(body) {
    body.sections = 'cart-drawer';
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.sections && cart.sections['cart-drawer']) replaceCartDrawer(cart.sections['cart-drawer']);
      refreshCartCount();
      openDrawer(cartDrawer());
    });
  }

  // Abrir carrito desde el header
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-toggle]');
    if (t) { e.preventDefault(); openDrawer(cartDrawer()); }
  });

  // +/- y quitar dentro del drawer (delegación)
  document.addEventListener('click', function (e) {
    var item = e.target.closest('.cd-item');
    if (!item || !e.target.closest('.cart-drawer')) return;
    var key = item.dataset.key;
    var qtyEl = item.querySelector('.cd-qty span');
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    if (e.target.closest('[data-cd-plus]')) cartChange({ id: key, quantity: qty + 1 });
    else if (e.target.closest('[data-cd-minus]')) cartChange({ id: key, quantity: Math.max(0, qty - 1) });
    else if (e.target.closest('[data-cd-remove]')) cartChange({ id: key, quantity: 0 });
  });

  // Interceptar "Agregar al carrito" (form de producto) → AJAX + abrir drawer
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action$="/cart/add"], form#product-form, form[action*="/cart/add"]')) return;
    var btn = e.submitter;
    if (btn && btn.name === 'checkout') return; // "Comprar ahora" va directo al checkout
    e.preventDefault();
    var fd = new FormData(form);
    var id = fd.get('id');
    var qty = parseInt(fd.get('quantity'), 10) || 1;
    if (!id) { form.submit(); return; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }], sections: 'cart-drawer' })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data.sections && data.sections['cart-drawer']) replaceCartDrawer(data.sections['cart-drawer']);
      refreshCartCount();
      openDrawer(cartDrawer());
    });
  });

  // ---------- Buscador ----------
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-toggle]');
    if (t) {
      e.preventDefault();
      var sd = document.getElementById('SearchDrawer');
      openDrawer(sd);
      var input = sd && sd.querySelector('[data-search-input]');
      if (input) setTimeout(function () { input.focus(); }, 80);
    }
  });

  (function () {
    var input = document.querySelector('[data-search-input]');
    var results = document.querySelector('[data-search-results]');
    if (!input || !results) return;
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('#shopify-section-predictive-search');
            results.innerHTML = inner ? inner.innerHTML : html;
          });
      }, 250);
    });
  })();

  /* ---------- Colección: slider de precio ---------- */
  document.querySelectorAll('[data-price-slider]').forEach(function (slider) {
    var max = parseInt(slider.dataset.max, 10) || 100;
    var rMin = slider.querySelector('[data-price-range-min]');
    var rMax = slider.querySelector('[data-price-range-max]');
    var fill = slider.querySelector('[data-price-fill]');
    var iMin = document.querySelector('[data-price-input-min]');
    var iMax = document.querySelector('[data-price-input-max]');
    function paint() {
      var a = Math.min(+rMin.value, +rMax.value);
      var b = Math.max(+rMin.value, +rMax.value);
      fill.style.left = (a / max * 100) + '%';
      fill.style.width = ((b - a) / max * 100) + '%';
    }
    paint();
    rMin.addEventListener('input', function () { if (+rMin.value > +rMax.value) rMin.value = rMax.value; if (iMin) iMin.value = rMin.value; paint(); });
    rMax.addEventListener('input', function () { if (+rMax.value < +rMin.value) rMax.value = rMin.value; if (iMax) iMax.value = rMax.value; paint(); });
    rMin.addEventListener('change', submitFilters);
    rMax.addEventListener('change', submitFilters);
    if (iMin) iMin.addEventListener('input', function () { rMin.value = iMin.value || 0; paint(); });
    if (iMax) iMax.addEventListener('input', function () { rMax.value = iMax.value || max; paint(); });
  });
})();
